import React from 'react';
import styled from 'styled-components';
import { LoadingContent } from 'common/LoadingContent';
import { Icon, IconProps, Typography } from '@beeline.com/bp-design-system';
export const DrawerContextTitle: React.FC<
  React.PropsWithChildren<{
    loading?: boolean;
    systemIconProps?: Partial<IconProps>;
    icon?: React.ReactNode;
    children: React.ReactNode;
    dataTest?: string;
  }>
> = ({ loading, systemIconProps = { name: 'work' }, icon, children, dataTest }) => {
  const { name, ...iconProps } = systemIconProps ?? {};
  return (
    <StyledTypography variant="body2" dataTest={dataTest}>
      <StyledIdSection data-test="context-title">
        {icon || <Icon size="medium" name={name ?? 'work'} {...iconProps} />}
        <LoadingContent skeletonProps={{ width: 100 }} loading={loading}>
          {children}
        </LoadingContent>
      </StyledIdSection>
    </StyledTypography>
  );
};
const StyledTypography = styled(Typography)`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
`;
const StyledIdSection = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: ${({ theme }) => theme.spacingSize.m};
`;
